import { ModalProps, Modals } from "..";
import { Loading } from "../../../atoms/Loading";
import * as S from "./ModalLoading.style";

interface ModalLoadingProps extends ModalProps {
  timerRunning?: boolean;
  modalText?: string;
}

export const ModalLoading = ({
  setModalShow,
  timerRunning,
  modalTitle,
  modalText,
}: ModalLoadingProps) => {
  return (
    <Modals
      modalTitle={modalTitle && modalTitle}
      setModalShow={setModalShow && setModalShow}
      // modalButtons={
      //   <Buttons
      //     type="button"
      //     size="md"
      //     layout="secondary"
      //     label="닫기"
      //     onClick={() => setModalShow(false)}
      //   />
      // }
    >
      <S.ModalLoadingTextBox>
        <Loading />
        {modalText && modalText}
        {/* <Stopwatch isRunning={timerRunning || false} /> */}
      </S.ModalLoadingTextBox>
    </Modals>
  );
};
